import useUnderageStore from 'stores/underageStore';
import type { UnderageSubmissionData } from 'types/underage';

const useUnderage = () => {
  const store = useUnderageStore();

  const uploadImage = (base64Image: string, filename: string, fileType: 'face' | 'idcard'): Promise<void> => {
    const data = {
      data: base64Image,
      filename,
      fileType,
    };
    return UnderageManager.uploadImage(data);
  };

  const submit = (data: UnderageSubmissionData): Promise<boolean> => {
    return UnderageManager.submit(data);
  };

  return {
    // States
    capturedFile: store.capturedFile,
    idCardFile: store.idCardFile,
    createdAt: store.createdAt,
    isUploading: store.isUploading,
    isFromVerification: store.isFromVerification,

    // Actions
    setCapturedFile: store.setCapturedFile,
    setIdCardFile: store.setIdCardFile,
    setUploading: store.setUploading,
    setFromVerification: store.setFromVerification,
    getSubmissionData: store.getSubmissionData,
    reset: store.reset,

    // UnderageManager methods
    uploadImage,
    submit,
  };
};

export default useUnderage;
